angular.module('currency')
    .directive('currencyPicker', function ($filter, $timeout, Currency) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {
                required: "=",
            },
            template: `
                <div>
                    <select class="form-control input-sm" ng-model="selected" ng-change="onChange(selected)" title="{{ 'currency' | translate}}" ng-required="required"
                            ng-options="u for u in items ">
                        <option value="">{{ 'currency.select' | translate}}</option>
                    </select>
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {

                Currency.query().$promise
                    .then(items => items.map(it => it.symbol))
                    .then(items => {
                        scope.items = items
                        ngModelCtrl.$render()
                    });

                scope.onChange = value => {}

                ngModelCtrl.$render = () => {
                    scope.selected = ngModelCtrl.$viewValue

                    if (scope.selected && scope.methods) {
                        let elemExists = scope.methods
                            .find(it => it === scope.selected)

                        if (elemExists) {
                            scope.selected = elemExists
                        } else {
                            let custom = scope.selected.symbol
                            scope.methods.push(custom)
                            scope.selected = custom
                        }
                    }
                };
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => viewValue)

                scope.$watch('selected', () => {
                    ngModelCtrl.$setViewValue(scope.selected)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                })
            }
        }
    })
